// 戶的詳情 ›「家戶成員」卡的規則（vms#33；權限照 App / app-api：assignableRoles、canManageMember）。
import type { HomeMember } from "../../lib/orgTreeApi";
import type { OrgMember } from "../../lib/planeApi";

export type HomeRole = "admin" | "member" | "guest";

/** 我能指定的角色：owner → 管理員 / 成員 / 訪客；admin → 成員 / 訪客；其他人只看清單（UX-11）。 */
export function assignableHomeRoles(myRole: string): HomeRole[] {
  if (myRole === "owner") return ["admin", "member", "guest"];
  if (myRole === "admin") return ["member", "guest"];
  return [];
}

/** 我能不能改 / 移出這個人（不含自己；owner 誰都不能動，要走交接）。 */
export function canManageHomeMember(myRole: string, m: HomeMember): boolean {
  if (m.is_me) return false;
  if (myRole === "owner") return m.role !== "owner";
  if (myRole === "admin") return m.role === "member" || m.role === "guest";
  return false;
}

/** 移出：只有直接指定 / 覆寫的角色拿得掉；跟著組織角色（default）的人要從組織移出。 */
export function canRemoveHomeMember(myRole: string, m: HomeMember): boolean {
  return canManageHomeMember(myRole, m) && m.role_source !== "default";
}

/** 〔加入成員〕可以挑的人：組織裡 active、還不在這一戶的人。 */
export function addableOrgMembers(
  org: OrgMember[],
  home: HomeMember[],
): OrgMember[] {
  const inHome = new Set(home.map((m) => m.user_id));
  return org.filter((m) => m.status === "active" && !inHome.has(m.user_id));
}

/** 名字：顯示名 → email → user_id。 */
export function memberLabel(m: {
  display_name?: string;
  email?: string;
  user_id: string;
}): string {
  return m.display_name?.trim() || m.email || m.user_id;
}
